// ============================================================
// Which body plate figure a character is drawn as, when the GM pins one
// (plan body-map, Track R3).
//
// Normally the figure is DERIVED from the sheet's traits and never stored
// (figureFor, plan Track P): Quadruped draws a beast, Machine a machine, the
// Xenos flag the alien version, and so on. This optional pin overrides that
// for one character - the only way to the Robot and the Daemon (ruling
// 2026-10-09). Absent means Automatic: old sheets stay byte-identical.
//
// A person's figure only: vehicles keep their vehicleKind, the amorphous
// mass its goo. Visual only, never a rule.
//
// Pure. Zero React dependency.
// ============================================================

import { PLATE_FIGURE_IDS, type PlateFigureId } from './plate/figureArt';

export type FigureKind = PlateFigureId;

export const FIGURE_KINDS: readonly FigureKind[] = PLATE_FIGURE_IDS;

export const FIGURE_LABELS: Record<FigureKind, string> = {
  human: 'Human',
  astartes: 'Astartes',
  beast: 'Beast',
  xenos: 'Xenos',
  xenobeast: 'Xenos beast',
  machine: 'Machine',
  xenos4a: 'Xenos, four arms',
  machine4a: 'Machine, four arms',
  xenostail: 'Xenos, serpent tail',
  xenostail4a: 'Xenos, serpent tail and four arms',
  robot: 'Robot',
  machinetrack: 'Machine on tracks',
  machinetrack4a: 'Machine on tracks, four arms',
  daemon: 'Daemon',
};

/** A stored value read back: one of the figures, or null (Automatic) for anything else. */
export function readFigure(value: unknown): FigureKind | null {
  return FIGURE_KINDS.find((k) => k === value) ?? null;
}
